import { Button, Flex, VStack } from '@hover/blueprint';
import { hBack } from '@hover/icons';
import React from 'react';
import { useHistory } from 'react-router';

import { useIsMobileSize } from 'src/modules/renderings/hooks';
import { TranslationNamespace, useTranslate } from 'src/shared/hooks';

interface OnboardingFormFooterProps {
  hideForMobile?: boolean;
}

export const OnboardingFormFooter = ({
  hideForMobile = true,
}: OnboardingFormFooterProps) => {
  const t = useTranslate(TranslationNamespace.SHARED);
  const history = useHistory();

  const isMobile = useIsMobileSize();

  const goBack = () => history.goBack();

  if (hideForMobile && isMobile) {
    return null;
  }

  return (
    <VStack display="flex" mt={300} width={1}>
      <Flex justifyContent="space-between" width={1}>
        {!isMobile && (
          <Button fill="minimal" iconBefore={hBack} onClick={goBack}>
            {t('onboarding.back')}
          </Button>
        )}
        <Button type="submit" width={{ base: 1, tablet: 'auto' }}>
          {t('onboarding.next')}
        </Button>
      </Flex>
    </VStack>
  );
};
